module.exports = __webpack_public_path__ + "static/media/logo.4341d0a9.svg";